import {Component, ViewChild, OnInit} from '@angular/core';
import { environment } from '../../environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { AuthService } from "../auth.service";
import { UtilsService } from "../shared/shared.module";
import {Observable} from "rxjs/Observable";
import * as _ from "lodash";

declare let swal:any;

@Component({
  selector: 'app-notification-center',
  templateUrl: './notification-center.component.html',
  styleUrls: ['./notification-center.component.css']
})
export class NotificationCenterComponent implements OnInit {

  errors: any = {};
  isLoading: boolean = false;

  environment: any;
  notif: any = {
    title: '',
    text: '',
    recipients: [],
    type: 'CAMPAIGNS'
  };

  possibleChoice: any = [
    {value: 'CAMPAIGNS', text: 'Campagnes'},
    {value: 'PHARMACIES', text: 'Pharmacies'}
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private utilsService: UtilsService,
    private authService: AuthService,
  ) { }

  ngOnInit() {
  }

  selectChanged() {
    this.notif.recipients = [];
  }

  getList = (text: string, init: boolean = false): Observable<Response> => {
    let query = "?search=" + text + "&limit=10";
    if (this.notif.type === 'CAMPAIGNS') {
      return this.http.get(environment.API_PATH + '/campaign' + query, {withCredentials: true})
	    .map(data => {
        return data['rows'];
      });
    }
    else {
      return this.http.get(environment.API_PATH + '/pharmacy' + query, {withCredentials: true})
	    .map(data => {
        return data['rows'];
      });
    }
  };

  matchingFn () {
    return true;
  }

  valueChange(field) {
    delete this.errors[field];
  }

  submitForm(form) {
    if (form.invalid || this.notif.recipients.length <= 0) {
      if (this.notif.recipients.length <= 0)
        this.utilsService.displayNotif("Vous devez ajouter au moins un destinataire", "danger");
      return;
    }

    this.isLoading = true;

    this.http.post(environment.API_PATH + '/admin/send-notifications', this.notif, {withCredentials: true})
    .subscribe(data => {
      this.isLoading = false;
      this.utilsService.displayNotif('La notification va être envoyée', 'success');
      this.router.navigate(['administration', 'home']);
    }, err => {
      this.isLoading = false;
      if (err.status === 401) {
        var errors = err.error;
        if (errors.error) {
          if (errors.error.status === 401) {

            this.router.navigate(['/connexion']);
          } else if (errors.error.status === 403) {
            if (errors.error.details.redirect)
              this.router.navigate([errors.error.details.redirect]);
            else if (errors.error.redirect) {
              this.router.navigate([errors.error.redirect]);
            }
            else
              this.authService.logout()
          } else {
            this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
          }
        } else {
          this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
        }
      } else if (err.status == 400) {
        var details = err.error.error.details;
        if (!_.isEmpty(details)) {
          this.authService.logout();
        }
      }
      else {
        this.utilsService.displayNotif("Une erreur est survenue, merci de réessayer", "danger");
      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/notification-center/notification-center.component.ts